// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__xCvrw","body":"styles_body__w5K6v","title":"styles_title__M7hvL","options":"styles_options__iPYa6","option":"styles_option__MGpS7"};